import { Button } from "@mantine/core";
import IconAlertTriangle from "@src/assets/icons/tabler/alert-triangle.svg?react";
import { openPlanModal } from "@src/components/plan/plan-modal/plan-modal";
import { PlanStatus } from "@src/gql/graphql";
import { getTrialTimeRemaining } from "@src/utils/get-trial-days-remaining";
import clsx from "clsx";
import { useMyPlan } from "./queries/fetch-plan";

const URGENT_THRESHOLD_DAYS = 1;
const WARN_THRESHOLD_DAYS = 3;

export function TrialBanner() {
	const { data: plan } = useMyPlan();
	if (plan?.status !== PlanStatus.InTrial || !plan.trialEnd) {
		return null;
	}

	const remaining = getTrialTimeRemaining(plan.trialEnd);

	if (!remaining) return null;

	const daysEquivalent =
		remaining.unit === "day"
			? remaining.value
			: remaining.unit === "hour"
				? 0
				: 0;

	const isWithinWarnThreshold =
		daysEquivalent <= WARN_THRESHOLD_DAYS ||
		remaining.unit === "hour" ||
		remaining.unit === "minute";

	if (!isWithinWarnThreshold) return null;

	const isUrgent =
		daysEquivalent <= URGENT_THRESHOLD_DAYS ||
		remaining.unit === "hour" ||
		remaining.unit === "minute";

	const { value, unit } = remaining;
	const label = value === 1 ? unit : `${unit}s`;
	const countdownText = `${value} ${label}`;

	const message = isUrgent
		? `Your Pro Trial ends in ${countdownText}. Image models, Thinking models, and advanced exports will be locked.`
		: `Your Pro Trial ends in ${countdownText}. Upgrade to keep all features.`;

	return (
		<div
			role="alert"
			className={clsx(
				"flex items-center justify-between gap-3 px-4 py-2.5 text-sm",
				isUrgent
					? "bg-amber-50 border-b border-amber-200 text-amber-800"
					: "bg-(--ui-color-brand-primary)/5 border-b border-(--ui-color-brand-primary)/20 text-brand-primary",
			)}
		>
			<div className="flex items-center gap-2 min-w-0">
				<IconAlertTriangle
					className={clsx(
						"w-4 h-4 shrink-0",
						isUrgent ? "text-amber-500" : "text-brand-primary",
					)}
				/>
				<span className="text-xs font-medium truncate">{message}</span>
			</div>

			<Button
				onClick={() => openPlanModal({ source: "trial_banner" })}
				size="xs"
				classNames={{
					root: clsx(
						"shrink-0 h-7 px-3 rounded-lg font-semibold text-xs border-none",
						isUrgent
							? "bg-amber-500 hover:bg-amber-600 text-white"
							: "bg-brand-primary hover:bg-brand-primary-hover text-text-inverse",
					),
				}}
				title="Upgrade now"
			>
				Upgrade Now
			</Button>
		</div>
	);
}
